module.exports = __webpack_public_path__ + "static/media/joint_account_not_holder.cc05e99f.svg";